<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div>
                    <div class="container">
                        <div class="titleBox">
                            <div>申请信息：</div>
                        </div>
                        <el-form class="dataFormBox" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="项目部：">
                                        <el-input v-model="dataForm.projectDeptName" :readonly="true" placeholder="请输入项目部" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="项目名称：">
                                        <el-input v-model="dataForm.projectName" :readonly="true" placeholder="请输入项目名称" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="欠款单位：">
                                        <el-input v-model="dataForm.debtName" :readonly="true" placeholder="请输入欠款单位" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="项目地点：">
                                        <el-input v-model="dataForm.projectAddress" :readonly="true" placeholder="请输入项目地点" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="发票抬头：">
                                        <el-input v-model="dataForm.billHead" :readonly="true" placeholder="请输入发票抬头" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="纳税人识别号：">
                                        <el-input v-model="dataForm.billTaxNumber" :readonly="true" placeholder="请输入纳税人识别号" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="地址：">
                                        <el-input v-model="dataForm.address" :readonly="true" placeholder="请输入地址" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="电话：">
                                        <el-input v-model="dataForm.phone" :readonly="true" placeholder="请输入电话" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="开户行：">
                                        <el-input v-model="dataForm.bank" :readonly="true" placeholder="请输入开户行" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="账号：">
                                        <el-input v-model="dataForm.bankAccount" :readonly="true" placeholder="请输入账号" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                  <el-form-item label-width="120px" label="发票类型：">
                                    <el-input v-model="dataForm.categoryDisplayName" :readonly="true" placeholder="请选择发票类型" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                  <el-form-item label-width="120px" label="发票种类：">
                                    <el-input v-model="dataForm.typeDisplayName" :readonly="true" placeholder="请选择发票种类" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="税率：">
                                        <el-input v-model="dataForm.taxRatio" :readonly="true" placeholder="请输入税率" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="发票金额：">
                                        <el-input v-model="dataForm.price" :readonly="true" placeholder="请输入发票金额" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="不含税金额：">
                                        <el-input v-model="dataForm.notTaxPrice" placeholder="请输入不含税金额" clearable :readonly="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="税额：">
                                        <el-input v-model="dataForm.taxPrice" placeholder="请输入税额" clearable :readonly="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item style="width: 100%" label-width="120px" label="发票备注：">
                                        <el-input v-model="dataForm.remark" show-word-limit
                                                  type="textarea" :rows="2" maxlength="200"
                                                  placeholder="请输入发票备注" clearable :readonly="true"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="titleBox">
                            <div>其他信息：</div>
                        </div>
                        <el-form class="dataFormBox" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="申请人：">
                                        <el-input v-model="dataForm.currentUserName" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="申请时间：">
                                        <el-input v-model="dataForm.approveTime" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label-width="120px" label="审批状态：">
                                        <el-input v-model="dataForm.approveStatusDisplayName" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="titleBox">
                            <div>收款记录：</div>
                        </div>

                        <div style="margin: 30px 20px 0;">
                            <collection-records :tableData="selectRecordList" ></collection-records>
                        </div>
                    </div>
                </div>
                    </el-tab-pane>
                    <el-tab-pane label="发票信息" name="Tab2" style="height: 700px;overflow-y: auto">
                        <el-form class="dataFormBox" :inline="true" :model="userForm">
                            <el-row v-for="(billItem,billIndex) in billList" :key="'billItem'+ billIndex"
                                    class="billList">
                                <el-col :span="8">
                                    <el-form-item label-width="100px" label="发票号码：">
                                        <el-input v-model="billItem.billNumber" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="发票金额：">
                                        <el-input v-model="billItem.billPrice" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item class="uploadBox" label-width="120px" label="发票附件：">
                                        <div class="inputImgBox" v-if="billItem.isShowImg">
                                            <el-image
                                                    style="width: 75px;height: 45px;"
                                                    :src="billItem.billUrl"
                                                    :preview-src-list="[billItem.billUrl]">
                                            </el-image>
                                        </div>
                                        <div class="inputImgBox blueColor" v-else @click="uploadBill(billItem.typeUrl,billItem.billUrl)">下载发票附件</div>

                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab3" style="height: 700px;overflow-y: auto">
                        <div>
                            <el-table :data="fileList" style="width: 100%; margin: 20px"
                                      size="mini" border>
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column
                                        v-for="(prop, index) in tableProps"
                                        :key="index"
                                        :prop="prop.prop"
                                        :label="prop.label"
                                        :min-width="prop.width"
                                ></el-table-column>
                                <el-table-column label="操作" width="150">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                @click="downloadFile(scope.$index, scope.row)"
                                                type="text"
                                        >下载附件</el-button>
                                        <el-button
                                                size="mini"
                                                @click="previewFile(scope.$index, scope.row,'document')"
                                                type="text"
                                        >预览</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                  <el-tab-pane label="审批过程" name="Tab4">
                    <div v-if="approveFlag === 'currentApprove' || approveFlag=== 'commonMessage'">
                      <approveItem
                          :itemId="contractId"
                          :approveType="approveType"
                          :subapproveType="subapproveType"
                          @finishApprove="reset()"
                      >
                      </approveItem>
                    </div>
                    <div v-else>
                      <approveLine
                          :itemId="contractId"
                          :approveType="approveType"
                      ></approveLine>
                    </div>
                  </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import  {
        getApproveDetailService,
        getTempUrlService,
        getReceiptsSItemsListService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import {goBackApprove} from '@/page/approveComponents/approve';
    import deleteModule from "@/page/engineering/delete-module";
    import {previewFile} from "@/utils/index.js"
    import UploadFile from "./uploadFile";
    import CollectionRecords from './collection-records'
    export default {
        name: "salesInvoiceDetail",
        data(){
            return {
                dataForm:{
                    projectDeptId:'',
                    projectId:'',
                    debtName: '',
                    projectAddress: '',
                    billHead: '',
                    billTaxNumber: '',
                    address: '',
                    phone: '',
                    bank: '',
                    bankAccount: '',
                    notTaxPrice: '',
                    taxPrice: '',
                    taxRatio: '',
                    price: '',
                    remark: '',
                    approveTime: '',
                    categoryDisplayName: '',
                    typeDisplayName: '',
                    approveStatusDisplayName: '',
                    currentUserName: sessionStorage.getItem('name')
                },
                selectRecordList:[],
                userForm:{
                    licenseNumber:'',
                },
                fileList: [],
                tableProps: [
                    { prop: "name", label: "文件名称", width: "280px" },
                    { prop: "createUserName", label: "上传者", width: "140px" },
                    { prop: "createTime", label: "上传时间", width: "140px" },
                ],
                activeName: 'Tab1',
                billList: [{
                    approveId:'',
                    billNumber:'',
                    billPrice:'',
                    billAttachmentUrl:'',
                    fileList:[],
                }], //发票信息

                approveFlag: '', //审批状态
                approveType: "OUTPUT_BILL_APPROVE", //审批类型
                subapproveType: '',
                contractId: 0,
            }
        },
        components:{
          approveLine, //审批历史流程
          approveItem, //审批
          UploadFile,
          CollectionRecords,
        },
        methods:{
            onActive(menuCode) {
                this.approveId = this.tabRouteParam.approveFlag? this.tabRouteParam.id: this.tabRouteParam.approveId;
                this.getApproveDetail(); // 新建提报单，要先去获取一次审批流模板

                this.approveFlag = this.tabRouteParam
                    ? this.tabRouteParam.approveFlag
                    : "";
                this.contractId = this.tabRouteParam.approveFlag? Number(this.tabRouteParam.id): Number(this.tabRouteParam.approveId);
            },
            /**
             * 获取申请发票详情
             * */
            getApproveDetail(){
                let paramsData = {
                    approveId: this.approveId
                }
                getApproveDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm = res.data;
                        this.getReceiptsList();
                        this.dataForm.currentUserName = res.data.approveUserName;
                        if(res.data.billItemVOList){
                            this.billList = [];
                            res.data.billItemVOList.map((item,index) => {
                                this.billList.push({
                                    approveId: item.approveId,
                                    billNumber: item.billNumber,
                                    billPrice: item.billPrice,
                                    billAttachmentUrl: item.billAttachmentUrl,
                                    typeUrl: item.billAttachmentUrl.split('.')[1]
                                })
                                this.getTempUrl(item.billAttachmentUrl, index);
                            })
                        }
                        this.fileList = res.data.attachmentVOList;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询收款详情期数列表
             * */
            getReceiptsList(){
                let paramsData = {
                    projectId: this.dataForm.projectId,
                    outputBillApproveId: this.approveId
                }
                getReceiptsSItemsListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.selectRecordList = res.data
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取图片路径
             */
            getTempUrl(url,index){
                let params = {
                    filePath: url
                }
                getTempUrlService(params).then( res => {
                    if(res.code == 10000000){
                        this.billList[index].billUrl = res.data;
                        this.$nextTick(()=>{
                            if((this.billList[index].typeUrl).toLowerCase() == 'jpeg' ||(this.billList[index].typeUrl).toLowerCase() == 'jpg' ||
                                (this.billList[index].typeUrl).toLowerCase() == 'png'|| (this.billList[index].typeUrl).toLowerCase() == 'gif'){
                                this.billList[index].isShowImg = true;
                            }else{
                                this.billList[index].isShowImg = false
                            }
                        })
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });

            },
            uploadBill(typeUrl,billUrl){
                if((typeUrl).toLowerCase() == 'pdf'){
                    window.open(billUrl)
                }else{
                    exportExcelService2(billUrl).then(res1 => {
                        this.$message.success('导出成功');
                    });
                }
            },
            reset(){
              if(this.approveFlag){
                goBackApprove(this.approveFlag,'salesInvoiceDetail')
              }else{
                this.bus.$emit("tabClose", "salesInvoiceDetail");
                this.bus.$emit("navMenuChange", {
                  routeId: "salesInvoice"
                });
              }
            },
            //文件下载
            downloadFile(index, row) {
                let reqParam = {
                    filePath: row.attachmentItem
                };
                getTempUrlService(reqParam).then(
                    res => {
                        if (res.code == 10000000) {
                            //下载附件
                            const link = document.createElement('a');
                            // 这里是将链接地址url转成blob地址，
                            fetch(res.data).then(res => res.blob()).then(blob => {
                                link.href = URL.createObjectURL(blob)
                                // 下载文件的名称及文件类型后缀
                                link.download = row.name;
                                document.body.appendChild(link)
                                link.click()
                                //在资源下载完成后 清除 占用的缓存资源
                                window.URL.revokeObjectURL(link.href);
                                document.body.removeChild(link);
                            });
                            // exportExcelService2(res.data).then(res1 => {
                            //     this.$alert("下载成功", "提示", {
                            //         confirmButtonText: "确定"
                            //     });
                            // });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                );
            },
            //文件预览
            previewFile,
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
      .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
          height: 100%;
          overflow: hidden;

          .el-tabs__content {
            height: calc(100% - 140px);
            padding: 0 20px 20px;
            overflow: auto;

            .el-form-item {
              width: 100%;
            }

            .el-checkbox {
              line-height: 40px;
            }

            .el-textarea {
              min-width: 0px !important;
            }
            .el-cascader {
              width: 100%;
            }

            .el-form-item__content {
              width: calc(100% - 150px);

              .el-input {
                width: 100%;
              }
            }
          }
        }
      }
    }
    /deep/.el-main{
        height: auto !important;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .inputImgBox{
        display: flex;
        img {
            width: 75px;
            height: 45px;
            margin-right: 59px
        }
        div {
            color: rgba(25, 159, 255, 100);
            font-size: 14px;
        }
    }
    .blueColor{
        color: #409EFF;
        cursor:pointer
    }
    .containerBox {
      width: 100%;
      height: 36px !important;
      position: fixed;
      bottom: 44px;
      left: 0;
      text-align: start;
    }
    .btnMid {
      position: relative;
      left: 27%;
      bottom: 0px;
      display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
      bottom: 44px;
      z-index: 10;
    }

    /deep/.el-tabs__item{
        padding: 0 20px !important;
     }
</style>
